import KinoklubbTicket from "components/KinoklubbTicket";
import TicketButton from "components/TicketButton";
import { isSameDay } from "date-fns";
import { IShowsForMovie, ITheatreProgram } from "lib/types/Program";
import Show from "lib/types/Show";
import { useMemo } from "react";
import styled from "styled-components";

//#region [Styles]
const SShowsContainer = styled.div`
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
	justify-content: center;
	@media screen and (min-width: 641px) {
		padding: 0 30px;
	}

`;

const STicketButton = styled(TicketButton)`
	flex: 0 0 150px;

	overflow: hidden;

	&.odd .showDate {
		background: var(--color_ticketbutton_datebg_other, #000000);
		color: var(--color_ticketbutton_datetext_other, #ffffff);
	}
`;

const SKinoklubbTicket = styled(KinoklubbTicket)`
	max-width: 150px;
	border-radius: 0.3em;

`;

//#endregion

//#region [Props]
type ShowsProps = {
	data?: IShowsForMovie | ITheatreProgram;
	isKinoklubb?: boolean;
};
//#endregion

type ExpandedShow = {
	dateGroup: string;
} & Show;


//#region [Component]
export default function Shows({ data, isKinoklubb = false }: ShowsProps) {

	const shows = useMemo(() => {
		let prevDate: Date | null;
		let flag: boolean = false;
		if ((data?.shows?.length ?? 0) === 0) {
			return null;
		}
		return data?.shows?.map(show => {
			const s = show as ExpandedShow;

			if (prevDate === null) {
				prevDate = s.showStartDate;
			} else if (!isSameDay(prevDate, s.showStartDate)) {
				flag = !flag;
			}
			prevDate = s.showStartDate;
			s.dateGroup = flag ? "even" : "odd";
			return s;
		});
	}, [data]);


	if (!shows) {
		return null;
	}

	return <SShowsContainer>
		{isKinoklubb && <SKinoklubbTicket/>}
		{shows.map(show => <STicketButton key={show.ticketSaleUrl.toString()} show={show} showDate className={show.dateGroup} showPassed appendShowType />)}
	</SShowsContainer>

}
//#endregion